require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-your-savings-are-safe-at-financial-center.json") })
        }
      }, "path---articles-your-savings-are-safe-at-financial-center");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-your-savings-are-safe-at-financial-center!./.cache/json/articles-your-savings-are-safe-at-financial-center.json
// module id = 1975
// module chunks = 231608221292675